import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useTypedQuery } from "hooks";
import { AccountSettingsQueryKeys } from "modules/AccountSettings/queryKeys";
import { ApiInstance } from "utils/Api";

import type { TFunction } from "i18next";
import type { LandingPage } from "models";

const formatLandingPageOptions = (landingPages: LandingPage[], t: TFunction) =>
  landingPages.map(({ id, name }) => ({ key: id, value: id, text: t(`v8_${name}`) || name }));

export const useAccountLandingPagesQuery = () => {
  const { t } = useTranslation();

  return useTypedQuery({
    queryKey: AccountSettingsQueryKeys.landingPages,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data.landing_pages,
    select: useCallback((landingPages: LandingPage[]) => formatLandingPageOptions(landingPages, t), [t])
  });
};
